import styled from "styled-components";

import DashboardPage from "../components/Dashboard-new";

export const AdminPage = () => {
  return (
    <Wrapper>
      <DashboardPage />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;
